import React from 'react';
import styled from 'styled-components';
import { spaces, media } from '../../../shared/lib/styles';

const Grid = styled.div`
    margin-left: auto;
    margin-right: auto;
    padding-left: ${spaces.gutter}px;
    padding-right: ${spaces.gutter}px;
    max-width: 1300px !important;

    @media ${media('small')} {
        padding-left: ${spaces.halfGutter}px;
        padding-right: ${spaces.halfGutter}px;
    }
`;

export default Grid;
